export default "__VITE_ASSET__DUOpNSNb__"